export const thankYouSystemeHostMock = {
  gmail: {
    href: 'https://mail.google.com/mail/u/0/#search/from%3Anoreply%40systeme.io+in%3Aanywhere+confirm+your+email',
    logoAsset: 'gmail.png',
  },
  outlook: {
    href: 'https://outlook.live.com/mail/0/',
    logoAsset: 'outlook.png',
  },
} as const
